import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../../components/base/Icon";
import { FontAwesomeIcons } from "../../../../core/Types";
import { ActivityTimelineItem } from "../../models/AdminDashboardModel";

type Props = {
    items?: ActivityTimelineItem[]
}

function ActivityTimelineWidget(props: Props) {
    const items = props.items ?? [];
    return (
        <div className="card border-0 shadow-sm h-100">
            <div className="card-header border-0 pt-5">
                <div>
                    <h3 className="widget-title">Recent Activity</h3>
                    <div className="widget-subtitle">Latest events</div>
                </div>
            </div>
            <div className="card-body pt-3" style={{ maxHeight: 420, overflowY: "auto" }}>
                {items.length === 0 && (
                    <div className="text-center text-gray-500 py-8">
                        <Icon icon="clock" type="thin" size={48} className="text-gray-400 mb-3" />
                        <div>No recent activity</div>
                    </div>
                )}
                {items.map((it, i) => {
                    const content = (
                        <>
                            <div className={`timeline-icon bg-light-${it.color}`}>
                                <Icon icon={it.icon as FontAwesomeIcons} type="solid" size={14} className={`text-${it.color}`} />
                            </div>
                            <div className="flex-grow-1 min-w-0">
                                <div className="fw-bold text-gray-900 text-truncate">{it.title}</div>
                                {it.description && <div className="text-gray-600 fs-7 text-truncate">{it.description}</div>}
                                <div className="text-gray-500 fs-8 mt-1">{it.atText}</div>
                            </div>
                        </>
                    );
                    return it.link ? (
                        <Link key={i} to={it.link} className="timeline-row text-decoration-none">{content}</Link>
                    ) : (
                        <div key={i} className="timeline-row">{content}</div>
                    );
                })}
            </div>
        </div>
    );
}

export default ActivityTimelineWidget;
